import axios from 'axios'
import store from '@/store'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  //'https://portal-api-dev.unicampo.coop.br/',
  // baseURL: 'https://portal-api-hmg.unicampo.coop.br/',
  // baseURL: 'https://portal-api.unicampo.coop.br/',
  // baseURL: 'http://localhost:8000/',

  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content': 'application/json',
  }
})


http.interceptors.request.use(function (config) {
  config.headers.modulo = store.state.rotaAtual;

  return config
}, function (erro) {
  return Promise.reject(erro)
})

import * as tools from "@/tools";

http.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      const originalRequest = error.config;
      // Não exibir alerta de sessão se o erro for durante o próprio login
      const isLoginRequest = originalRequest.url && (originalRequest.url.includes('autenticacao') || originalRequest.url.includes('loginErp'));
      
      if (!isLoginRequest && !originalRequest._retryAlert) {
        originalRequest._retryAlert = true;
        tools.alerta("Sessão expirada. Por favor, faça login novamente.", "warning");
        store.commit("DESLOGAR_USUARIO");
        if (window.location.pathname !== "/login" && !window.location.hash.includes("/login")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default http
